import { createAction, props } from '@ngrx/store';
import { AppletAuditTrailContainer } from 'blg-akaun-ts-lib';

export const loadAuditTrailInit = createAction('[Audit Trail] Load Roles Init', props<{ request: any }>());
export const loadAuditTrailSuccess = createAction('[Audit Trail] Load Roles Success', props<{ totalRecords: number }>());
export const loadAuditTrailFailure = createAction('[Audit Trail] Load Roles Failure', props<{ error: string }>());
export const selectedAuditTrail = createAction('[Audit Trail] Select Audit Trail', props<{ auditTrail: AppletAuditTrailContainer }>());
export const updateAgGridDone = createAction('[Audit Trail] Update Ag-grid', props<{ done: boolean }>());
